<template>
    <div class="hpProg reveal">
        <div class="prog-container">
            <div class="section_title fxTextUp section-title">
                <div class="fxText" style="--index:0">
                    SCIENTIFIC PROGRAM
                </div>
            </div>              
            <div class="section_subtitle fxTextUp">
                <div class="fxText fs16" style="--index:1">
                    Palma de Mallorca 2024
                </div>
            </div>

            <div class="daysTabs" >
                <div class="daysTabs-item"></div>
                <div class="daysTabs-item tabMid">
                    <ul class="daysTabsList">
                        <li v-for="(dayItem,dIndex) in prog" :style="'--index:'+dIndex" :key="'day_'+dIndex" :class="[dIndex==day_index ? 'active':'']" 
                            @click="changeDay(dIndex)">
                            <a>
                                <span>{{dayItem.day_num}}</span>
                                <span>{{dayItem.day_name}}</span>
                            </a>
                        </li>
                    </ul>                        
                </div>
                <div class="daysTabs-item"></div>    
            </div>        

            <!-- start session items-->
            <div v-for="(dayItem,dIndex) in prog" :key="'daysessions_'+dIndex">

                <div :class="['sessions',dayItem.sessions.length==1 ? 'single':'']" v-if="dIndex==day_index">
                    <div class="session-item"                         
                        v-for="item in dayItem.sessions" :key="item.index">
                        
                        <!-- //////////////////////////////////////////////////////////////// -->
                        <div :class="['sepline','se-sep-top',isSepLineOpen ? 'opened':'']" :style="getFxIndex(item.index,0)"></div>
                        
                        <div class="se-head">
                            <div :class="['se-name','fxTextUp',item.color_class]">
                                <div class="fxText fs16" :style="getFxIndex(item.index,1)">{{item.se_name}}</div>
                            </div>
                            <div class="se-title fxTextUp">
                                <div class="fxText fs16" :style="getFxIndex(item.index,2)">{{item.se_desc}}</div>
                            </div>
                            <div class="se-speaker fxTextUp">
                                <div class="fxText fs14" :style="getFxIndex(item.index,2)">{{item.se_mod}}</div>
                            </div>
                        </div>

                        <!-- //////////////////////////////////////////////////////////////// -->
                        <div :class="['sepline','se-sep-bot',isSepLineOpen ? 'opened':'']" :style="getFxIndex(item.index,3)"></div>                    
                        
                        <div :class="['se-part',se_item.title ? 'active' :'',se_item.time.length==0 ? 'time-hidden':'time-hidden']"
                            v-for="(se_item, index) in item.se_times" 
                            @click="showAbstract(se_item)" :key="index">

                            <div class="se-time fxTextUp">                                
                                <div class="fxText fs12" :style="getFxIndex(item.index,4)">{{se_item.time}}</div>
                            </div>

                            <div class="se-desc">

                                <div class="se-speaker fxTextUp">
                                    <div :class="['fxText fs12']" 
                                        :style="'font-weight:300!important;padding-bottom:5px;'+getFxIndex(item.index,4)+';'+'color: var(--'+item.color_class+')'">
                                        {{se_item.time}}
                                    </div>
                                    <div class="fxText fs14" :style="getFxIndex(item.index,5+index)">
                                        {{se_item.speaker}}
                                    </div>
                                </div>
                                <div class="se-lecture fxTextUp">
                                    <div class="fxText fs14" :style="getFxIndex(item.index,6+index)">
                                        {{se_item.title}} 
                                            <!--<span v-if="se_item.content.length>0" :class="['fxPlus',item.color_class]">
                                            <span>></span>
                                            </span>-->
                                         <span v-if="se_item.content.length>0" 
                                            :style="'background-color: var(--'+item.color_class+')'"
                                            :class="['fxRoundArrow',item.color_class]">
                                            <span>></span>
                                         </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end session items-->

            <div class="xrBtn">
                <a class="white_btn color_btn animation_up" target="_blank" href="MIS_Global_Conference_Scientific_Program_Flyer.pdf">
                    <span class="title">Download scientific program</span>
                    <i class="fal fa-arrow-down pl-s" ></i>
                </a>
            </div>
            
        </div>
    </div>
</template>

<style>    
    .daysTabs
    {
        padding-top: 50px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 40px;
        clear: both;        
    }

    .tabMid
    {
        border: solid 1px #d1d1d1;
        margin: auto;
        width: 100%;
        opacity: 0;
        transition:all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    }
    .hpProg.reveal.active .tabMid
    {
        width: 100%;
        opacity: 1;
    }



    .daysTabsList
    {
        list-style: none;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;      
        max-width: 100%;
        grid-row-gap: 0rem; /* Will be used instead by browsers that do not support `row-gap` */
        row-gap: 0px; /* Used by browsers that support `row-gap` */
        column-gap: 0px;
        padding: 0px;
        margin: auto;
/*         opacity: 0;
        transition: all ease 0.8s;
        transition-delay: 0.8s;
 */    
    }
    .hpProg.reveal.active .daysTabsList
    {
        opacity: 1;
    }
    .daysTabsList li
    {        
        color:#676767;
        font-size: 12px;
        padding: 1.2vw 0px;
        transition: all ease-in-out 1s;
        transition-delay: calc(0.7s + (0.1s * var(--index))) !important;
        /* clip-path: inset(100% 0 0 0); */
        opacity: 0;
    }
    .hpProg.reveal.active .daysTabsList li
    {
        opacity: 1;
        /* clip-path: inset(0 0 0 0); */
    }


    .daysTabsList li:hover,
    .daysTabsList li.active
    {
        background-color: #202020;        
    }
    .daysTabsList li a span
    {
        color:#676767;
    }
    .daysTabsList li:hover a span,
    .daysTabsList li.active a span
    {
        color:#a5a5a5;
    }




    .daysTabsList li:nth-child(2)
    {
        border-left: solid 1px #d1d1d1;
        border-right: solid 1px #d1d1d1;
    }
    .daysTabsList li a
    {
        cursor: pointer;        
        width: 100%;
        height: 80px;        
    }
    .daysTabsList li a span
    {
        opacity: 1;
    }


    .daysTabsList li a span:nth-child(1)
    {
        font-size: 40px;
        font-weight: 600 !important;
        display: block;
        letter-spacing: -2px;
        line-height: 40px;
        width: 100%;
        text-align: center;
    }
    .daysTabsList li a span:nth-child(2)
    {
        font-size: 12px;
        display: block;
        width: 100%;
        text-align: center;
    }



    .color_btn
    {
        background-color: transparent;transition: all ease 0.3s;
    }
    .color_btn:hover
    {
        background-color:#fff;
    }
    .color_btn *{
        color:#202020 !important;
    }



    .hpProg .prog-container
    {
        margin: auto;
        width: clamp(800px,70vw,1800px);
        text-align: center;
    }
    .hpProg .prog-container .title
    {
        color:#202020;
    }


    .sessions
    {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 80px;
        row-gap: 30px;
        padding-top: 50px;
        clear: both;
    }
    .sessions.single
    {
        display: block;
        width: 30%;
        margin: auto;
    }

    
    .session-item {
        text-align: left;
        padding-bottom: 30px;
        border: solid 0px #202020;
    }    
    .session-item:nth-child(4)
    {
        grid-column: 2;
        grid-row: 2;
    }

    .session-item .se-head
    {
        min-height: 0px;
    }
    .se-name div, .se-name span
    {
        color: #b0deff;
        font-weight: 500 !important;
    }    

    :root
    {
        --color1:#652881;
        --color2:#d41528;
        --color3:#eb6b41;
        --color4:#50baa6;
        --color5:#37abdf;
    }
    .se-name.color1 div, .se-name.color1 span{color:#652881 !important;}
    .se-name.color2 div, .se-name.color2 span{color:#d41528 !important;}
    .se-name.color3 div, .se-name.color3 span{color:#eb6b41 !important;}
    .se-name.color4 div, .se-name.color4 span{color:#50baa6 !important;}
    .se-name.color5 div, .se-name.color5 span{color:#37abdf !important;}

    .se-title div,.se-title span{
        color: #202020;font-weight: 500 !important;
    }        

    .reveal.active .sepline
    {
        width: 1px !important;
    }
    .reveal.active .sepline.opened
    {
        width: 100% !important;
    }

    .se-sep-top
    {
        width: 1px;
        border-top: solid 1px #969696;line-height: 18px;height: 18px;opacity: 0.4;
        transition: all ease-in-out 1.2s;
        transition-delay: calc(0.2s + (0.15s * var(--index))) !important;
    }
    .se-sep-bot
    {
        width: 1px;
        border-bottom: solid 1px #969696;
        padding-top: 20px;opacity: 0.4;
        transition: all ease-in-out 2s;
        transition-delay: calc(0.2s + (0.15s * var(--index))) !important;
        margin-bottom: 10px;
    }
    .reveal.active .se-sep-top,
    .reveal.active .se-sep-bot
    {
        width: 100%;
    }

    .se-part
    {
        clear: both;
        padding-top: 10px;
        padding-bottom: 10px;
        display: grid;
        grid-template-columns: 60px auto;
    }
    .se-part.col1
    {
        grid-template-columns: 100%;
    }

    .se-part.time-hidden
    {
        grid-template-columns: 0px auto;
    }
    .se-part .se-time
    {
        text-align: left;
        font-weight: 200 !important;
        color:#000;
    }
    .se-part .se-desc
    {
        display: inline-block;
        text-align: left;
        color:#000;
    }
    
    /* .se-part .se-desc .se-speaker div */
    .se-speaker div
    {
        clear:both;
        font-weight: 200 !important;
        color:#000;
    }
    .se-part .se-desc .se-lecture
    {
        clear:both;
        font-weight: 400 !important;        
        color:#000;
        padding-top: 3px;
    }

    .hpProg
    {
      width: 100%;
    }

    /* ------------ Active animations ------------*/
    /* ------------ Active animations ------------*/
    .hpProg .split-text.subtitle .xLine .xLineText
    {
        font-weight: 300 !important;
    }
    .hpProg .split-text.title .xLine .xLineText
    {
        font-weight: 200 !important;
    }


    .hpProg .cols
    {
        padding-top: 60px;
        display: flex;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        grid-auto-rows: 20px;
        grid-gap: 5px;
        width: 80%;
        margin: auto;
    }

    .hpProg .fxPlus
    {
        cursor: pointer;
        font-weight: 400 !important;
        font-size: inherit;
        color:#37abdf;        
        transform: scale(0.8,1);
        display: inline-block;
    }
    .hpProg .fxTextUp
    {
        overflow: hidden;
    }
    .hpProg .fxTextUp .fxText
    {
        opacity: 0;
        position: relative;
    }

    /* /// CIRCLE WITH ARROW /// */
    .fxRoundArrow
    {        
        width: 14px;
        height: 14px;
        display: inline-flex;
        border-radius: 100%;
        position: relative;
        top: 3px;
        align-content: center;
        opacity: 0.5;
        transition: all ease 0.3s;
    }
    .fxRoundArrow span
    {        
        font-size: 11px;
        color: #fff;
        font-weight: 400 !important;
        display: inline-block;
        position: absolute;
        top: calc(50% - 1px);
        left: 50%;
        transform: translate(-50%,-50%) scale(0.6,1);        
    }
    .se-part:hover .fxRoundArrow
    {
        opacity: 0.8;
    }





    .hpProg .fxTextUp.section_title .fxText {
/*         font-size: 44px;
        letter-spacing: -1px !important;
        font-weight: 200 !important;
 */        padding-bottom: 5px;
        color:#202020;
        text-align: center;
    }
    .hpProg .fxTextUp.section_subtitle .fxText {
        font-weight: 200 !important;
        padding-bottom: 10px;
        color:#202020;
        text-align: center;
    }


    .hpProg  .session-item .fxTextUp.title .fxText {
        font-size: 18px;
        font-weight: 500 !important;
        padding-bottom: 10px;
    }
    .hpProg .session-item .fxTextUp.expend .fxText {
        font-weight:inherit;
    }
    .hpProg .session-item .fxTextUp.expend .fxText i{
        font-size: 12px;
    }



    .hpProg.reveal.active .fxTextUp div
    {
        animation-delay: calc(0.2s + (0.15s * var(--index))) !important;
        animation: textUp 1s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        animation-fill-mode:forwards;
    }    
    @keyframes textUp {
        from {transform: translateY(40px);opacity: 0;}  
        to {transform: translateY(0);opacity: 1;}
    }

    .fxCircleNum
    {
        opacity: 0;
        border: solid 3px #8dbbdb;
        border-radius: 100%;
        width: 90px;
        height: 90px;
        align-items: center;
        text-align: center;
        margin: auto;
        margin-bottom: 20px;
        transform: translate(-50%,20px);
        padding-top: 19px;
        transition: all ease-out 0.6s;
        transition-delay: calc(0.1s * var(--index)) !important;
    }
    .fxCircleNum span:nth-child(1)
    {
        position: relative;
        font-size: 33px;
        line-height: 33px;
        font-weight: 800 !important;  
        display: block;      
        height: 30px;
        overflow: hidden;
        clear: both;
    }
    .fxCircleNum span:nth-child(2)
    {
        display: block;      
        font-size: 11px;
        line-height: 12px;
        font-weight: 500 !important;        
        opacity: 0.7;
    }
    .hpProg.reveal.active .fxCircleNum
    {
        opacity: 1;
        transform: translate(-50%,0px);
    }    

@media (hover: hover) {
    .se-part.active:hover
    {
        background-color: #f2f2f2;
        cursor: pointer;
    }    
}


  @media (max-width: 850px) { 
    .hpProg .prog-container
    {
      width: 80vw;
    }
    .daysTabs
    {
        display: block;
        width: 100%;
    }
    .daysTabsList
    {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        column-gap: 0px;
    }
    .daysTabsList li 
    {
        padding: 15px 0px;
    }

    .session-item:nth-child(4)
    {
        grid-column: inherit;
        grid-row: inherit;
    }


    .sessions.single 
    {
        width: 100%;
    }

    .hpProg .fxTextUp.section_subtitle .fxText {
        font-size: 16px;letter-spacing: 0px !important; 
    }
    .sessions
    {
        grid-template-columns: 1fr;
        column-gap: 80px;
        row-gap: 30px;
        padding-top: 30px;
    }
    .session-item {
        text-align: left;
        padding-bottom: 30px;
        border: solid 0px #202020;
    }    
    .session-item .se-head
    {
        min-height:50px;
        height: auto !important;
    }

    .hpProg .cols
    {
        padding-top: 20px;
        display: block;
        margin: auto;
        width: 100%;
    }
    .hpProg .session-item
    {
        width: 100%;
    }
    .hpProg .fxCircleNum {
        transform: translate(0,0);
        margin: initial;
    }
    .hpProg.reveal.active .fxCircleNum {
        transform: translate(0,0);
    }    
    .hpProg .xrBtn
    {
        width: 100%;
    }
    .hpProg .session-item .fxTextUp.title {
        padding-top: 10px;
    }
    .hpProg .fxTextUp.section_title .fxText {
        /* font-size: 24px; */
    }    
    .hpProg .split-text.title div,
    .hpProg .split-text.title .xLine .xLineText
    {
        font-weight: 200 !important;
        font-size: 24px !important;
    }

     /* Portrait iPad mini 1, iPad 1 and iPad 2*/
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: portrait)
    {
        .sessions
        {
            grid-template-columns: 1fr 1fr;
            column-gap: 50px;row-gap: 30px;padding-top: 50px;
        }     
    }

    /* Landscape iPad mini 1, iPad 1 and iPad 2 */
    @media only screen 
    and (min-device-width: 768px) 
    and (max-device-width: 1024px) 
    and (-webkit-min-device-pixel-ratio: 1) 
    and (orientation: landscape)
    {
    }   
  }

  /* LARGE SCREENS */
  @media (min-width: 1600px) { 

    .daysTabsList li a span:nth-child(1){
        font-size: 60px;
        line-height: 60px;
    }
    .daysTabsList li a span:nth-child(2) {
        font-size: 18px;
    }
  }  
</style>

<script>
import site_data from "@/site_data.json"
export default {
  data() {
    return {
        isSepLineOpen:true,
        day_index:0,
        prog:site_data[0].PROGRAM
    }
  },
  mounted()
  {
    this.setHeights();
  },
  methods:
  {
    setHeights()
    {
        //on mobile media query 
        //we will use height:auto !important to override this logic

        var sessionHeaders = document.querySelectorAll(".se-head");
        //alert(sessionHeaders.length);
        //return false;

        var shHeights = [];
        for (let i = 0; i < sessionHeaders.length; i++) 
        {
            if(sessionHeaders.length==4 && i==3)
            {
                //when using 4 cols, do not affect the last
            }else
            {
                let elBox = sessionHeaders[i].getBoundingClientRect();
                let elH = elBox.height;
                shHeights.push(elH);            
            }
        }

        let maxH = Math.max(...shHeights);
        for (let i = 0; i < sessionHeaders.length; i++) 
        {
            if(sessionHeaders.length==4 && i==3)
            {
                //when using 4 cols, do not affect the last
            }
            else
            {
                let headEl = sessionHeaders[i];
                headEl.style.height = maxH+'px';
            }
        }
 
        //console.log(allDivsHeight);//just for debugging
        //console.log(Math.max(...allDivsHeight))
    },
    changeDay(new_day_index)
    {
        var vm = this;
        this.day_index=new_day_index;
        ////////////////////////////////////////////////////////////////////////////////
        //workaround for fixing the sep lines bug
        //when chamging dates we need to force the lines to animate again

        this.isSepLineOpen = false;
        setTimeout(() => {
            vm.setHeights();
            vm.isSepLineOpen=true;
        }, 400);

        ////////////////////////////////////////////////////////////////////////////////
    },
    showAbstract(item)
    {
        if(item.content.length>0)
        {            
            this.$emit("showprogramitem",item);//sessionIndex,lectureIndex
        }
    },
    getFxIndex(index,addIndex)
    {
      let fxIndex = (index+addIndex);
      return '--index:' + fxIndex;
    },
  }
};
</script>

